export default {
  title: 'Vue d’ensemble',
  subtitle: 'Suivez la répartition des demandes entre les trois flux.',
  periods: {
    week: '7 jours',
    month: '1 mois',
  },
  refreshed: 'Actualisé il y a 2 min',
  received: 'Demandes reçues',
  receivedShort: 'demandes reçues',
  trend: 'vs période précédente',
  evolution: 'Évolution des flux',
  evolutionTooltip: '{day} : {total} demandes',
  split: 'Répartition des flux',
  zones: 'Répartition par zone de départ',
  zone: 'Zone de départ',
  total: 'Total',
  legend: {
    leads: 'Vente de leads',
    premium: 'Premium',
    online: 'Online',
  },
};
